module.exports = __webpack_public_path__ + "img/icon_map_4_on_001.7a4b0b77.png";